import React from 'react';
import {useFormikContext} from 'formik';
import {Autocomplete, Card, TextField} from '@mui/material';

const durationUnit = [
  {name: 'Days', id: 'days'},
  {name: 'Weeks', id: 'weeks'},
  {name: 'Months', id: 'months'},
  {name: 'Years', id: 'years'},
]

export default function LoanEntryThree() {
  const {values, setFieldValue} = useFormikContext();

  const getSelectedDuration = (type) => {
    const selected = durationUnit?.find(val => (val?.id === type));
    return selected;
  }

  const selectedDurationUnit = getSelectedDuration(values?.duration_unit);

  return (
    <div>
      <Card className={'box-shadow'} sx={{p: 4, paddingBottom: 5}}>
        <TextField 
          variant={'outlined'} 
          size={'small'} 
          fullWidth 
          label={'Purpose'}
          value={values?.purpose || ''}
          onChange={(e) => setFieldValue('purpose', e.target.value)}
          sx={{mt: 1.5}}
          InputLabelProps={{
            style: {fontSize: 14, color: '#929191'},
            shrink: true
          }}
        />
        <TextField 
          variant={'outlined'} 
          size={'small'} 
          fullWidth 
          label={'Duration'}
          value={values?.duration || ''}
          onChange={(e) => setFieldValue('duration', e.target.value)}
          sx={{mt: 1.5}}
          InputLabelProps={{
            style: {fontSize: 14, color: '#929191'},
            shrink: true
          }}
        />
        <Autocomplete
          key={values?.duration_unit}
          id="combo-box-demo"
          options={durationUnit}
          value={selectedDurationUnit}
          getOptionLabel={(option) => option?.name}
          size={'small'}
          className="dob mr-2 mt-3"
          onChange={(e, value) => {
            setFieldValue('duration_unit', value?.id);
          }}
          isOptionEqualToValue={(option, value) => option?.id === value?.id}
          renderInput={(params) => (
            <TextField 
              {...params}
              label="Duration unit" 
              sx={{mt: 1.5}}
              InputLabelProps={{style: {color: '#929191', fontSize: 14}, shrink: true}}
            />
          )}
        />
        <TextField 
          variant={'outlined'} 
          size={'small'} 
          fullWidth 
          label={'Agency Loaned To'}
          value={values?.agency_loaned_to || ''}
          onChange={(e) => setFieldValue('agency_loaned_to', e.target.value)}
          sx={{mt: 1.5}}
          InputLabelProps={{
            style: {fontSize: 14, color: '#929191'},
            shrink: true
          }}
        />
        <TextField 
          variant={'outlined'} 
          size={'small'} 
          fullWidth 
          label={'Issue Date'}
          value={values?.issue_date || ''}
          onChange={(e) => setFieldValue('issue_date', e.target.value)}
          type={'date'}
          sx={{mt: 1.5}}
          InputLabelProps={{
            style: {fontSize: 14, color: '#929191'},
            shrink: true
          }}
        />
        <TextField 
          variant={'outlined'} 
          size={'small'} 
          fullWidth 
          label={'Return Date'}
          value={values?.return_date || ''}
          onChange={(e) => setFieldValue('return_date', e.target.value)}
          type={'date'}
          sx={{mt: 1.5}}
          InputLabelProps={{
            style: {fontSize: 14, color: '#929191'},
            shrink: true
          }}
        />
        <TextField 
          variant={'outlined'} 
          size={'small'} 
          fullWidth 
          label={'Recommendation'}
          value={values?.recommendation || ''}
          onChange={(e) => setFieldValue('recommendation', e.target.value)}
          sx={{mt: 1.5}}
          InputLabelProps={{
            style: {fontSize: 14, color: '#929191'},
            shrink: true
          }}
        />
      </Card>
    </div>
  );
}